import { groq } from 'next-sanity';
import { z } from 'zod';

import { image, SanityImage } from './image';

export const SanityVideoEmbed = z.object({
  _type: z.literal('videoEmbed'),
  _key: z.string(),
  title: z.string(),
  badge: z.string().optional().nullable(),
  thumbnailImage: SanityImage,
  videoUrl: z.string(),
});

export type SanityVideoEmbed = z.infer<typeof SanityVideoEmbed>;

export const videoEmbed = groq`{
  _type,
  defined(_key) => {
    _key,
  },
  title,
  badge,
  thumbnailImage ${image},
  videoUrl,
}`;
